var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"logo-horizontal"},[_c('img',{attrs:{"src":require("@/assets/images/logo/logo_crew_horizontal_white_bg.svg"),"width":"166","height":"54"}})])
}]

export { render, staticRenderFns }